import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
// componentes
import ZonaCargando from "../zonaCargando";
import SidebarCamarografo from "../../partials/sidebarCamarografo";
import SeleccionarDispositivo from "./seleccionarDispositivo";

function TorneoIndividualGrabar(){

    
    const navigate    = useNavigate();
    const routeParams = useParams();
    let {username, idTorneo} = routeParams; // capturamos para paginación

    const [usuario, setUsuario]                      = useState(null);
    const [siguientePagina, setSiguientePagina]      = useState(null);
    const [paginaAnterior, setPaginaAnterior]        = useState(null); 
    const [cantidadDePaginas, setCantidadDePaginas]  = useState(null);
    const [infoUsuarioLocal, setInfoLocal]           = useState(null); // Variables localstorage
    const [torneos, setTorneos]                      = useState(null);
    const [cargando, setCargando]                    = useState(false);
    const [torneo, setTorneo]                      = useState(null);
    const [fechas, setFechas] = useState(null);
    
 
    const urlVolver   = "/camarografo/grabar/" + routeParams.username + "/1";
 

    useEffect(() => {
    (async () => {
      try {
        setCargando(true);

        const verifToken = axios.get("/verificar-token", { withCredentials: true });
        const pFechas    = axios.post("/obtener-fechas-torneo-grabar", { params: { idTorneo: idTorneo } });

        const [ resVerif, resFechas ] = await Promise.all([verifToken, pFechas ]);
        if(!resVerif.data.usuario){ return navigate("/alerta", {state: {titulo:"No estás autenticado", mensaje:"No estás autenticado, por favor inicia sesión.", urlMensaje:"/iniciar-sesion", nombreBoton:"Volver a iniciar sesión"} } ); }
        if(resVerif.data.usuario.tipo === "Administrador" || resVerif.data.usuario.tipo === "Cliente" ){ cerrarSesion(); return navigate("/alerta", {state: {titulo:"No eres Camarógrafo", mensaje:"No eres camarógrafo.", urlMensaje:"/iniciar-sesion", nombreBoton:"Volver a iniciar sesión"} } ); }
        setUsuario(resVerif.data.usuario);
        // fechas
        setFechas(resFechas.data.fechas); 
        setTorneo(resFechas.data.torneo);
        
      } 
      catch (err) { console.error("Error en una de las solicitudes:", err); } 
      finally { setCargando(false);}
    })();
    }, []);


    async function cerrarSesion(event) {
        localStorage.clear(); // Limpiamos el almacenamiento local.
        const resCerrar = await axios.post("/logout");
    }

    
    

    return(
    <div>
    {cargando ? <ZonaCargando /> : 
    !usuario ? null : 
        <div className='contenedorPaginasUsuario'>
            <div className='contenedorSidebarYcontenido d-flex flex-row '>
                {/* BARRA LATERAL */}
                <SidebarCamarografo />


                {/* Columna 2 */}
                <div className="flex-grow-1 container-fluid">
                    
                    {/* Contenedor título  */}
                    <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom border-light">
                        <h1 className="h2 text-light">Grabar</h1>
                        {/* Avatar y saludo */}
                        <div className="d-flex align-items-center">
                            <h4 className="textoHomeUsuario mx-2 text-light">Hola {usuario.username}</h4>
                        </div>
                    </div>

                   

                    {/* Primer contenedor: imagen principal */}
                    {(torneo) 
                    ? <div className='container'>
                        <div className="p-5 my-4 contenedorOscuro rounded-3">
                            <div className="row  d-flex align-items-center" style={{ minHeight: "400px" }}>
                                {/* Imagen */}
                                <div className="col-lg-6 d-flex justify-content-center">
                                        <div className="d-flex justify-content-center"> <img className="imagenPrincipal" src={torneo.imagen}  alt="" /></div>
                                </div>

                                {/* Nombre y texto */}
                                <div className="col-lg-6 d-flex justify-content-center">
                                    <div className="container-fluid py-5">
                                        <h1 className="display-5 fw-bold">Torneo {torneo.nombre}</h1>
                                        <p className="col-md-8 fs-4">Deporte: {torneo.deporte}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    : null}



                    {/* fechas */}
                    {torneo ? (
                    <div className="container mb-5 mt-3">
                        <h3 className="text-center my-5 text-light">Ver fechas</h3>
                        <p className="text-light">Si ves que este torneo tiene fecha 0, es porque este torneo no se le han asignado fechas a los partidos.</p>

                        {/* Verifica si cantidadDeFechas es 0 */}
                        {torneo.cantidadDeFechas === 0 ? (
                        <div className="row">
                            <div className="col-lg-4 mb-4">
                            <div className="card contenedorOscuro">
                                <div className="card-header">{torneo.nombre}</div>
                                <div className="card-body">
                                <h5 className="card-title">Fecha 0</h5>
                                <p className="card-text">Videos de fecha 0</p>
                                <a href={"/camarografo/grabar/" + username + "/fecha/" + 0 + "/torneo/" + idTorneo } className="btn btn-primary w-100">
                                    Ver fecha 0
                                </a>
                                </div>
                            </div>
                            </div>
                        </div>
                        ) : (
                        [...Array(torneo.cantidadDeFechas)].map((_, i) => (
                            // Cada 3 elementos comenzamos una nueva fila
                            i % 3 === 0 ? (
                            <div className="row" key={`row-${i}`}>
                                {[...Array(3)].map((_, j) => {
                                // Calcula el índice de la tarjeta actual
                                const index = i + j;
                                const numeroFecha = index + 1;
                                // Verifica si el índice no supera la cantidad de fechas disponibles
                                return index < torneo.cantidadDeFechas ? (
                                    <div className="col-lg-4 mb-4" key={index}>
                                    <div className="card contenedorOscuro">
                                        <div className="card-header">{torneo.nombre}</div>
                                        <div className="card-body">
                                        <h5 className="card-title">Fecha {index + 1}</h5>
                                        <p className="card-text">Videos de fecha {index + 1}</p>
                                        <a href={"/camarografo/grabar/" + username + "/fecha/" + numeroFecha + "/torneo/" + idTorneo } className="btn btn-primary w-100">
                                            Ver fecha {index + 1}
                                        </a>
                                        </div>
                                    </div>
                                    </div>
                                ) : null;
                                })}
                            </div>
                            ) : null
                        ))
                        )}
                    </div>
                    ) : null}

                </div>
            </div>
        </div> 
    }
    </div>
    )
}

export default TorneoIndividualGrabar;